import { MessagesSquare } from 'lucide-react'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'
import { sdk } from '@/lib/sdk'
import { FeedbackSpaceFields } from '@/components/features/feedbacks/FeedbackSpaceFields'
import {
  defaultFeedbackSpaceConfig,
  feedbackSpaceConfigFrom,
  feedbackSpaceErrorsFromApi,
  saveFeedbackSpaceConfig,
  validateFeedbackSpaceConfig
} from '@/components/features/feedbacks/feedbackSpaceConfig'

const FeedbacksPage = lazyPage(() => import('@/pages/Feedbacks'), 'FeedbacksPage')

export const feedbacksModule: ModuleDefinition = {
  key: 'feedbacks',
  icon: MessagesSquare,
  iconName: 'messages-square',
  namespaces: ['feedbacks'],
  ready: true,
  /* The space is a personal inbox (Recebidos, Enviados, Pedidos). */
  ListPage: FeedbacksPage,
  /* One short setting (extension 2), on the details step (PADROES-UI section 14), saved by `PUT /feedbacks/settings`. */
  setup: {
    wizardStep: 'details',
    defaultConfig: () => defaultFeedbackSpaceConfig(),
    validate: (config, t) => validateFeedbackSpaceConfig(config, t),
    Fields: FeedbackSpaceFields,
    persist: {
      type: 'endpoint',
      save: (spaceId, config) => saveFeedbackSpaceConfig(spaceId, config),
      load: async (spaceId) => feedbackSpaceConfigFrom(await sdk.feedbacks.getSettings(spaceId)),
      errorsFromSaveFailure: (err) => feedbackSpaceErrorsFromApi(err)
    }
  }
}
